import { ChainId } from '@pancakeswap/chains'
import { supportedChainId } from '@pancakeswap/farms'

export const SUPPORT_ONLY_PULSE = [ChainId.PULSE]
export const SUPPORT_FARMS = supportedChainId
export const SUPPORT_BUY_CRYPTO = [
]

export const LIQUID_STAKING_SUPPORTED_CHAINS = [
]
export const FIXED_STAKING_SUPPORTED_CHAINS = []

export const V3_MIGRATION_SUPPORTED_CHAINS = []
